module.exports = __webpack_public_path__ + "NPIicon.png?9d7886600d24be7e37e8caebd0b11b4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/NPIicon.png
// module id = 43
// module chunks = 0